module.exports = __webpack_public_path__ + "img/button_scale_01.9ffe5abb.png";